import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { useProductConfigurationsFromProductLineAndLevel } from '../../hooks/upgradePageHooks';
import { useAppSelector } from '../../reducers';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import CurrentPlanButton from '../../upgrade-page/CurrentPlanButton';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
import FeatureTableCTA from './FeatureTableCTA';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableHeaderCell = styled.th.withConfig({
  displayName: "CompareProFeatureTableHeaderCell__TableHeaderCell",
  componentId: "sc-4f2t71-0"
})(["text-align:center;font-weight:normal;position:relative;width:", ";padding:16px 0;"], ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  position: 'static'
};
const ctaStyles = {
  width: '212px',
  padding: '11px'
};
const CompareProFeatureTableHeaderCell = ({
  productLevel,
  columns,
  productLine,
  upgradePointProductLevel,
  ownedProductColumn,
  upgradePointApiName,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  upgradeKey,
  feature
}) => {
  const isHighlightedCell = upgradePointProductLevel === productLevel;
  // Seats scenarios have only one column because we don't have an additional column for a product to compare.
  const isSeatsScenario = columns <= 1;
  const productConfigurations = useProductConfigurationsFromProductLineAndLevel({
    productLine,
    productLevel
  });
  const currencyCode = useAppSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    columns: columns,
    scope: "col",
    children: [isHighlightedCell && /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: 'new',
      translationKey: 'recommended',
      badgeStyle: badgeStyle
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "flex-column m-top-1",
        message: `merchCards.businessObjectives.suite.${productLevel}.${productLine}.title`
      })
    }), ownedProductColumn && !isSeatsScenario ? /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(CurrentPlanButton, {
        ctaStyles: Object.assign({}, ctaStyles, {
          visibility: 'visible'
        }),
        productLine: productLine
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: productConfigurations && productConfigurations.length && /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(FeatureTableCTA, {
          currencyCode: currencyCode,
          productConfigurations: productConfigurations,
          upgradePointApiName: upgradePointApiName,
          upgradeKey: upgradeKey,
          purchaseMotions: purchaseMotions,
          ctaStyles: Object.assign({}, ctaStyles),
          handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
          feature: feature
        })
      })
    })]
  }, productLevel);
};
export default CompareProFeatureTableHeaderCell;